import React, { useEffect } from "react";
import styles from "./Chat.module.scss";
import { useHistory } from "react-router-dom";
import { Button } from "@blueprintjs/core";
import { withSendBird, sendBirdSelectors } from "sendbird-uikit";

function ChatButton() {
  const history = useHistory();

  return (
    <Button
      onClick={() => history.push("/chat")}
      className={styles.chatBtn}
      icon={"chat"}
      large
      minimal
    />
  );
}

const ButtonWithSendBird = withSendBird(ChatButton, (state) => {
  return {
    sdk: sendBirdSelectors.getSdk(state)
  };
});

const App = () => (
  <div>
  <ButtonWithSendBird />
  </div>
);

export default App;
